class SideEffect {
    constructor() {
        this.init();
    }

    filterClose = () => {
        const filter = document.querySelectorAll('[data-filter-layout="horizontal"] .horizontal--open-js-btn');
        const shortBy = document.querySelector(".facets-short-by")
        filter.forEach((itm) => {
            itm.addEventListener("click", (event) => {
                filter.forEach((item) => {
                    if (item !== itm) {
                        item.classList.remove("menu-opening");
                        item.removeAttribute("open");
                    }
                });
                if(shortBy){
                    shortBy.removeAttribute("open")
                }
            });
        });
    };
    
    openfilterHorizontal = () => {
        document.addEventListener("DOMContentLoaded", () => {
            const removeOpenMobile = document.querySelector('[data-filter-layout="horizontal"] .horizontal--class');
            if (removeOpenMobile && window.innerWidth < 990) {
                removeOpenMobile.removeAttribute("open");

            }
        });
    }

    openShortBy = () => {
        const shortBtn = document.querySelector(".facets-short-by .sorting-button")
        const filter = document.querySelectorAll('[data-filter-layout="horizontal"] .horizontal--open-js-btn');
        document.addEventListener('click',(e)=>{
            if(e.target.closest('[data-filter="sort-by"]') || e.target.classList.contains('horizontal--open-js-btn') || e.target.closest('#FacetSortDrawerForm')){

            }else{
                const shortBy = document.querySelector(".facets-short-by")
                if(shortBy){
                    shortBy.removeAttribute("open")
                }
            }
        })
        if(shortBtn){
            shortBtn.addEventListener("click",()=>{
                const shortWrapper = shortBtn.closest(".facets-short-by");
                const shortForm = shortBtn.closest("#FacetSortDrawerForm.facet_sortby-form");
                const isOpen = shortWrapper.toggleAttribute("open");
                filter.forEach((item) => {
                    item.classList.remove("menu-opening");
                    item.removeAttribute("open");
                });
            })
        }
    }

    init = () => {
        this.openfilterHorizontal();
        this.filterClose()
        this.openShortBy()
    }
}

new SideEffect();
